import { fetchJson, fetchResponse } from "src/utils/apiUtils";

type IFileUploadResp = {
  files: IFileUpload[];
};

export const upload = async (files: File[]) => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append("files", file);
  });

  return fetchJson<IResponse<IFileUploadResp>>(`files/upload`, {
    method: "POST",
    body: formData,
    noContentType: true
  });
};

export const download = async (fileId: FileUploadId) => {
  return fetchResponse(`public/file/${fileId}`, {
    method: "GET",
    noContentType: true
  });
};

export const info = async (fileId: FileUploadId) => {
  return fetchJson<IResponse<IFileUpload>>(`files/info/${fileId}`, {
    method: "GET"
  });
};
